import React from "react";
import "./Header.css";
import { Link } from "react-router-dom";



function Header() {

    const scrollToSection = (id) => {
        const section = document.getElementById(id);
        if (section) {
            section.scrollIntoView({ behavior: "smooth" });
        }
    };
    return (
        <header className="header">
            <div className="header-container">
                <div className="social-icons">
                    <a href="#" className="social-link">
                        <i className="fab fa-facebook-f"></i>
                    </a>
                    <a href="#" className="social-link">
                        <i className="fab fa-linkedin-in"></i>
                    </a>
                    <a href="#" className="social-link">
                        <i className="fab fa-instagram"></i>
                    </a>
                    <a href="#" className="social-link">
                        <i className="fab fa-youtube"></i>
                    </a>
                </div>
                <div className="about">
                    <a href="tel:000:000:00" className="contact-info" >
                        <i style={{color:"#00A5E7" , fontSize:"16px"}} className="fas fa-phone-alt"></i>
                        <span>Call Us: 000:000:0000</span>
                        <span className="space">|</span>
                    </a>
                    <div className="schedule">
                        <i style={{fontSize:"16px"}} className="fas fa-clock"></i>
                        <span>Sun-Thu 8:00a-5:00p</span>
                        <span className="space">|</span>
                    </div>
                    <div>
                        <a onClick={() => scrollToSection("aboutus-section")} className="about-link">About</a>
                    </div>
                </div>
            </div>
        </header>
    );
}

export default Header;
